import { grayColor} from "assets/jss/material-dashboard-pro-react.js";

const styles = {
    boxEnd: {
      width:'80px',height:'80px',textAlign:'center',borderRadius:'50%',
      border:'2px solid green',lineHeight:'80px',verticalAlign:'middle',color:'green'
    },
    icoBoxEnd:{
      fontSize:'45px'
    },    
    modalLarge: {
      maxWidth: "1024px",
      width: '80%'
    },
    modalTitle: {
      margin: "0",
      lineHeight: "1.42857143"
    },
    modalCloseButton: {
      color: grayColor[0],
      marginTop: "-12px",
      WebkitAppearance: "none",
      padding: "0",
      cursor: "pointer",
      background: "0 0",
      border: "0",
      fontSize: "inherit",
      opacity: ".9",
      textShadow: "none",
      fontWeight: "700",
      lineHeight: "1",
      float: "right"
    },
    modalClose: {
      width: "16px",
      height: "16px"
    },
};
  
export default styles;